class DataObject {
  dataSosial: object = {
    pasien: {
      rm_dash: "---",
      nama: "---",
      tgl_lahir: "",
      alamat: "- - -",
      usia: {
        th: "",
        bln: "",
        hr: ""
      }
    },
    asuransi: {
      nama: "-"
    },
    register: "-"
  };

  soap = {};

  copySoap = "0";

  filterCari = {
    tanggal: "",
    status: "",
    dokter: "",
    count: 0
  };
}

export default new DataObject();
